/* eslint-disable @typescript-eslint/no-unused-vars */
import { FORMA_PAGO } from "api/Types/FormaPago"
import {
  getImpuestoCondition,
  handleJoinDuplicates,
  handleUpdateImpuestoShape,
} from "features/Crear/components/ConceptosTable/utils"

const getTax = (list = [], taxId = "") => {
  // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
  return list.find((tax) => tax.id === taxId)
}

const prepareConceptos = (
  conceptos: $TSMigrationFixMe,
  sinValorar: $TSMigrationFixMe,
  taxes: $TSMigrationFixMe
) => {
  return conceptos.map((concepto: $TSMigrationFixMe) => ({
    articulo: {
      concepto: concepto.concepto,
      precioVenta: sinValorar ? null : concepto.precioVenta,
      tipoArticulo: 1,
    },

    impuestoEmpresaRepercutidoId: concepto.impuestoRepercutidoId,
    cantidad: concepto.cantidad,

    impuestoRepercutido: getTax(
      taxes,
      concepto.impuestoArticuloTipoId
      // @ts-expect-error TS(2339): Property 'grupoImpuesto' does not exist on type 'n...
    )?.grupoImpuesto?.categoria,

    porcentajeRepercutido: sinValorar
      ? null
      : concepto.impuestoArticuloPorcentaje,

    totalRepercutido: 0,
  }))
}

const ENUMS = {
  PRESUPUESTO: 25,
  PEDIDO: 24,
  ALBARÁN: 18,
  FACTURA: 2,
}

const mapDocumentoToPdf = (
  documento: $TSMigrationFixMe,
  sinValorar: $TSMigrationFixMe,
  observacionCesion: $TSMigrationFixMe,
  formaPagoIban: $TSMigrationFixMe,
  totalRetencion = null,
  tiposImpuestosGenerales: $TSMigrationFixMe,
  isLibrador: $TSMigrationFixMe
) => {
  const impuestosTotales = handleJoinDuplicates(
    documento.conceptos,
    getImpuestoCondition,
    handleUpdateImpuestoShape
  )
  const mapTiposImpuestos = () => {
    return impuestosTotales.map(
      ({
        impuestoArticuloPorcentaje,
        totalImpuesto,
        impuestoArticuloTipoId,
      }: $TSMigrationFixMe) => ({
        impuestoPorcentaje: impuestoArticuloPorcentaje,
        impuestoValor: totalImpuesto,
        tipoImpuesto: tiposImpuestosGenerales.find(
          (entry: $TSMigrationFixMe) => entry.id === impuestoArticuloTipoId
        )?.grupoImpuesto.categoria,
      })
    )
  }
  return {
    logoAsFileBase64: documento.logo?.split(",")[1],
    articuloDocumentos: prepareConceptos(
      documento.conceptos,
      sinValorar,
      documento?.extra
    ),
    librado: {
      codigoPostal: documento.librado.cp,
      direccion: documento.librado.direccion,
      email: documento.librado.email,
      nif: documento.librado?.cif,
      poblacion:
        documento.librado.poblacion || documento.librado.poblacionExtranjera,
      provincia: documento.librado.provincia,
      razonSocial: documento.librado.razonSocial,
      telefono: documento.librado.telefono,
    },
    librador: {
      codigoPostal: documento.librador.cp,
      direccion: documento.librador.direccion,
      email: documento.librador.email,
      nif: documento.librador?.cif,
      poblacion:
        documento.librador.poblacion || documento.librador.poblacionExtranjera,
      provincia: documento.librador.provincia,
      razonSocial: documento.librador.razonSocial,
      telefono: documento.librador.telefono,
    },
    numero: documento.numero,
    serie: documento.serie,
    archivosAdjuntos: documento.archivosAdjuntos,

    ...(isLibrador && {
      fechaVencimiento:
        typeof documento.fechaVencimiento === "string"
          ? documento.fechaVencimiento
          : new Intl.DateTimeFormat("es-ES", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
              .format(documento.fechaVencimiento)
              .split("/")
              .reverse()
              .join("-"),
    }),
    documentosAsociados: documento?.documentosAsociadosMsg
      ? documento?.documentosAsociadosMsg
          .split(":")[1]
          .split(",")
          .map((d: $TSMigrationFixMe) => {
            return {
              tipoDocumento:
                // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
                ENUMS[
                  documento?.documentosAsociadosMsg
                    .split(":")[0]
                    .trim()
                    .toUpperCase()
                ],
              numero: d.split("-")[1].trim(),
              serie: d.split("-")[0].trim(),
            }
          })
      : [],
    fechaEmision:
      typeof documento.fechaEmision === "string"
        ? documento.fechaEmision
        : new Intl.DateTimeFormat("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
            .format(documento.fechaEmision)
            .split("/")
            .reverse()
            .join("-"),
    fechaOperacion: documento.fechaOperacion
      ? new Date(documento.fechaOperacion)
      : null,
    configuracion: {
      color: documento.colorSelected,
    },
    descuento: sinValorar ? null : documento.descuento,
    descuentoValor: sinValorar
      ? null
      : Math.abs((documento.subtotal * documento.descuento) / 100) * -1,
    divisa: documento.divisa,
    retencion: sinValorar ? null : documento.retencion,
    observaciones: observacionCesion
      ? `${observacionCesion}\n${documento.observaciones || ""}`
      : documento.observaciones || null,
    formaPago: documento.formaPago,
    ...(isLibrador &&
      (documento.formaPago === FORMA_PAGO.TRANSFERENCIA ||
        documento.formaPago === FORMA_PAGO.PAGO_DOMICILIADO) &&
      formaPagoIban !== "" && { iban: formaPagoIban }),
    diasPago: documento.diasPago,
    porcentajeRetenido: sinValorar ? null : documento.retencionPorcentaje,
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param...
    RetencionValor: Math.abs(totalRetencion) * -1,
    impuestoRetenido: documento.impuestoRetenido,
    importe: documento.importe,
    subtotal: documento.subtotal,
    tiposImpuestos: mapTiposImpuestos(),
  }
}

export default mapDocumentoToPdf
